import React from "react";
import { addCommasNumbers, dateWithMonthAndTimeString } from "../utilities/utils";

const HistoryDetailsModal = ({ show, onHide, historyDetails }) => {
    if (!show) return null;

  return (
    <div
      className={`modal fade ${show ? "show" : ""}`}
      tabIndex="-1"
      role="dialog"
      data-backdrop="static"
      style={{
        display: show ? "block" : "none",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
      }}
    >
      <div className="modal-dialog"  role="document">
        <div
          className="modal-content modal"
        >
          {/* Header START */}
          <div
            className="modal-header headerModals"
            style={{
              position: "sticky",
              top: 0,
              zIndex: 10,
              backgroundColor: "#64748b",
              color: "#fff",
            }}
          >
            <h5 className="modal-title">Transaction Details</h5>
            <button
              type="button"
              className="close"
              aria-label="Close"
              onClick={onHide}
            >
              <span aria-hidden="true" style={{ color: "#fff" }}>
                &times;
              </span>
            </button>
          </div>
          {/* Header END */}

          {/* Body START */}
          <div
            className="modal-body"
            style={{
              overflowY: "auto",
              maxHeight: "400px",
              backgroundColor: "#f8f9fa",
            }}
          >
            <div className="row">
              <div className="col-4 mb-1">
                <strong>Player Account:</strong>
              </div>
              <div className="col-8">{historyDetails.Player || ""}</div>
            </div>
            <div className="row">
              <div className="col-4 mb-1">
                <strong>Transaction ID:</strong>
              </div>
              <div className="col-8">{historyDetails.IDTransaction || ""}</div>
            </div>
            <div className="row">
              <div className="col-4 mb-1">
                <strong>Transaction Type:</strong>
              </div>
              <div className="col-8">{historyDetails.TransactionTypeDescription || ""}</div>
            </div>
            <div className="row">
              <div className="col-4 mb-1">
                <strong>Description:</strong>
              </div>
              <div className="col-8">{historyDetails.Description || ""}</div>
            </div>
            <div className="row">
              <div className="col-4 mb-1">
                <strong>Amount:</strong>
              </div>
              <div className="col-8">{addCommasNumbers(historyDetails.Amount) || 0}</div>
            </div>
            <div className="row">
              <div className="col-4 mb-1">
                <strong>Fee:</strong>
              </div>
              <div className="col-8">{historyDetails.Fee || 0}</div>
            </div>
            <div className="row">
              <div className="col-4 mb-1">
                <strong>Bonus:</strong>
              </div>
              <div className="col-8">{historyDetails.Bonus || 0}</div>
            </div>
            <div className="row">
              <div className="col-4 mb-1">
                <strong>Payment Method:</strong>
              </div>
              <div className="col-8">{historyDetails.PaymentMethod || ""}</div>
            </div>
            <div className="row">
              <div className="col-4 mb-1">
                <strong>Placed Date:</strong>
              </div>
              <div className="col-8">{dateWithMonthAndTimeString(historyDetails.PlacedDate) || ""}</div>
            </div>
            <div className="row">
              <div className="col-4 mb-1">
                <strong>User:</strong>
              </div>
              <div className="col-8">{historyDetails.LoginName || ""}</div>
            </div>
            <div className="row">
              <div className="col-4 mb-1">
                <strong>Reference:</strong>
              </div>
              <div className="col-8">{historyDetails.Reference || ""}</div>
            </div>
          </div>
          {/* Body END */}

          {/* Footer START */}
          <div
            className="modal-footer"
            style={{
              position: "sticky",
              bottom: 0,
              zIndex: 10,
              backgroundColor: "#fff",
              borderTop: "1px solid #dee2e6",
            }}
          >
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onHide}
            >
              Close
            </button>
          </div>
          {/* Footer END */}
        </div>
      </div>
    </div>
  );
};

export default HistoryDetailsModal;
